import axios from "axios";

// Unauthenticated client for patient-facing pages (no token, no login redirect)
const publicApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

export default publicApi;
